// extracted by mini-css-extract-plugin
export var closeButton = "_pw-2";
export var closeButtonIcon = "_pw-3";
export var lightboxContent = "_pw-1";
export var lightboxOverlay = "_pw-0";